import { PERIODO } from "api/Types/Periodo"
import { PERIODO_AMORTIZACION } from "api/Types/PeriodoAmortizacion"
import { TFunction } from "i18next"

export const tipoPeriodo = (t: TFunction) => ({
  [PERIODO.MENSUAL]: t("nsAssets.tipoPeriodo.mensual"),
  [PERIODO.TRIMESTRAL]: t("nsAssets.tipoPeriodo.trimestral"),
  [PERIODO.ANUAL]: t("nsAssets.tipoPeriodo.anual"),
})

export const tipoPeriodoAmortizacion = (t: TFunction) => ({
  [PERIODO_AMORTIZACION.MENSUAL]: t("nsAssets.tipoPeriodo.mensual"),
  [PERIODO_AMORTIZACION.ANUAL]: t("nsAssets.tipoPeriodo.anual"),
})
